import { createFileRoute } from '@tanstack/react-router';

import { USER_ROLES } from '~/features/auth/roles';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/abbott-admin/abbott')({
  component: RouteComponent,
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AdminAbbott, USER_ROLES.HcpAdmin],
    });
  },
});

function RouteComponent() {
  return <div>Hello from Abbott User Administration!</div>;
}
